const e = "_blockList_dw95h_1", t = "_quoteWrapper_dw95h_14", r = "_quote_dw95h_14", o = "_workTitle_dw95h_34", _ = "_imageWrapper_dw95h_37", p = "_image_dw95h_37", a = "_textWrapper_dw95h_51", s = {
  blockList: e,
  quoteWrapper: t,
  quote: r,
  workTitle: o,
  imageWrapper: _,
  image: p,
  textWrapper: a
};
export {
  e as blockList,
  s as default,
  p as image,
  _ as imageWrapper,
  r as quote,
  t as quoteWrapper,
  a as textWrapper,
  o as workTitle
};
